export default Object.freeze({
  TITLE: '회원 조회',
  SIMPLE_QUERY: '간편조회',
  BASIC_INFORMATION: '기초정보',
  TYPE: '회원유형',
  STATUS: '회원상태',
  GRADE: '회원등급',
  GROUP: '회원그룹',
  CERTIFICATION: '본인인증',
  BLACKLIST: '블랙리스트',
  BLACKLIST_MEMBER: '블랙리스트 회원',
  JOIN_DATA: '회원가입일',
  JOIN_WAY: '회원가입경로',
  ACTIVITY: '활동량',
  POINT: '적립금',
  LOGIN_COUNT: '로그인 회수',
  LAST_LOGIN_DATA: '최종로그인일',
  LAST_LOGIN: '최종로그인',
  LONG_TIME_NOUSE_DATA: '장기 미사용 기간',
  LONG_TERM: '장기 미사용 회원',
  INFORMATION: '개인정보',
  INFORMATION2: '회원정보',
  GENDER: '성별',
  AGE: '연령대',
  AGREED: '마케팅 수신동의',
  APPPUSHAGREED: '앱푸시 수신동의',
  APPPUSHAGREED2: '푸시 수신동의',
  SMSAGREED: 'SMS 수신동의',
  EMAILAGREED: '이메일 수신동의',
  DMGREED: 'DM 수신동의',
  COMBINED_POP: '회원연동',
  COMBIN: '회원 통합',
  COMBINED: '회원통합여부',
  COMBINED_DT: '회원 연동일',
  COMBINED_DATA: '회원통합일',
  PUSH_NOTIFICATION: '푸시알림 수신',
  SMS_AGREED: 'SMS 수신',
  DM_AGREED: 'DM 수신',
  COLLECTION_AND_USE: '개인정보 수집/이용',
  PROCESS_CONSIGNMENT: '개인정보 처리/위탁',
  THIRD_PARTY_PROVISION: '개인정보 제3자 제공',
  BLACKLISTED: '블랙리스트 회원',
  PERIOD_SEARCH: '기간검색',
  CRMBUTTON_RATING: '회원등급 변경',
  CRMBUTTON_GROUP: '회원그룹 변경',
  CRMBUTTON_COUPON: '할인쿠폰 지급',
  COMBINED_AGREE: '연동함',
  COMBINED_NOTAGREE: '연동안함',
  PROHIBIT: '이용정지',
  EXPEL: '강제탈퇴',
  MODIFICATION_ACCUMULATION: '{0} 지급/차감',
  ORDER_NO: '주문번호',
  MEMBER_NO: '회원번호',
  ID: '아이디',
  NAME: '이름',
  NICKNAME: '닉네임',
  EMAIL: '이메일',
  EMAIL2: 'e메일 주소',
  MAILADDRESS: 'e메일주소',
  MOBILE: '휴대폰번호',
  AGE_COUNT1: '10대',
  AGE_COUNT2: '20대',
  AGE_COUNT3: '30대',
  AGE_COUNT4: '40대',
  AGE_COUNT5: '50대',
  AGE_COUNT6: '60대',
  AGE_OVER_COUNT6: '60대 이상',
  STATUS1: '가입대기',
  STATUS2: '가입완료',
  STATUS3: '휴면',
  STATUS4: '이용정지',
  MALL_NAME: '쇼핑몰',
  MEMBER_NAME: '회원명',
  ERROR_SELECT_MEMBER_COUNT: '회원을 선택해 주세요.',
  ALERT_SELECT_MEMBER_NONE: '회원을 선택해주세요.',
  ALERT_NON_MALL: '회원 검색 후 진행해야 합니다.',
  ALERT_NON_KEYWORD: '검색어를 입력하세요.',
  ALERT_NON_MEMBER: '등록된 회원정보가 없습니다.',
  ERROR_NON_MEMBER: '회원정보를 가져오는데 실패하였습니다.',
  ERR_NO_TYPES: '회원유형을 선택해주세요',
  ERR_ACC_PERIOD: '{0} 입력이 올바르지 않습니다.',
  ERR_LOGIN_CNT_PERIOD: '방문회수 입력이 올바르지 않습니다.',
  PLEASE_SEARCH: '회원을 조회해주세요.',
})
